import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import useRoomInfo from '../../components/RoomHeader/RoomInfo/useRoomInfoHooks';
import copyIcon from '../common/icons/CopyIcon.vue';
import SvgIcon from '../common/base/SvgIcon.vue';
import { isMobile, isWeChat } from '../../utils/environment';
import { useI18n } from '../../locales';
import { getUrlWithRoomId } from '../../utils/utils';

export default /*#__PURE__*/_defineComponent({
  __name: 'InvitePanel',
  props: {
    scheduleInviteList: null,
    shareLinkData: null
  },
  setup(__props: any) {

const props = __props as {
  scheduleInviteList?: {
    title: string;
    content: string;
    isShowCopyIcon: boolean;
    isVisible: boolean;
  }[];
  shareLinkData?: {
    roomId: string;
    password?: string;
    [key: string]: unknown;
  };
};

const { t } = useI18n();


const { onCopy } = useRoomInfo();
const scheduleInviteList = computed(() => {
  const { roomId, password } = props?.shareLinkData || {};
  if (!roomId) return props.scheduleInviteList;
  return [
    {
      title: `${t('Room ID')}`,
      content: roomId,
      isShowCopyIcon: true,
      isVisible: true,
    },
    {
      title: `${t('Room Password')}`,
      content: password,
      isShowCopyIcon: true,
      isVisible: !!password,
    },
    {
      title: `${t('Room Link')}`,
      content: getUrlWithRoomId(roomId),
      isShowCopyIcon: true,
      isVisible: !isWeChat,
    },
  ];
});

return { __sfc: true,t, props, onCopy, scheduleInviteList, copyIcon, SvgIcon, isMobile }
}

})